import React from 'react';
import BasicButton from './BasicButton';
import { defaultLink } from '@styles/app';

const DefaultLink: React.FC<any> = (props): JSX.Element => {
  return <BasicButton {...props} variant={defaultLink} />;
};

export default DefaultLink;
